import React, { useState, useEffect, useMemo } from 'react';
import {
    Container,
    Row,
    Col,
    Button,
    Modal,
    Form,
    Table,
    Dropdown,
    Spinner,
    Badge,
    Card,
    Alert
} from 'react-bootstrap';
import Select from 'react-select';
import makeAnimated from "react-select/animated";
import Header from '../../layouts/Header';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import axiosInstance from '../../api/axios';
const PurchaseUnits = () => {
    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const { access, email } = useSelector((state) => state.login);
    const [purchaseAccess, setPurchaseAccess] = useState([]);

    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("PurchaseUnits:")
            );
            setPurchaseAccess(filteredAccess);
        }
    }, [access]);

    const accessToken = localStorage.getItem('authToken');
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [purchaseUnits, setPurchaseUnits] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState("")
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [unitToDelete, setUnitToDelete] = useState(null);
    const [actionLoading, setActionLoading] = useState(false);
    const [purchaseData, setPurchaseData] = useState([]);
    const [selectedUnit, setSelectedUnit] = useState('');

    const [addFormData, setAddFormData] = useState({
        name: "",
        type: "",
        contactPerson: "",
        mobile: "",
        email: "",
        address: "",
        city: "",
        pincode: "",
        state: "",
        gstin: "",
    });

    const [editFormData, setEditFormData] = useState({
        name: "",
        type: "",
        contactPerson: "",
        mobile: "",
        email: "",
        address: "",
        city: "",
        pincode: "",
        state: "",
        gstin: "",
        // status: "ACTIVE"
    });

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [editingUnit, setEditingUnit] = useState(null);

    const animatedComponents = makeAnimated();

    const getPurchaseUnitsList = async (page, limit) => {
        setLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }

            const response = await axiosInstance.get(`procurement-units/list?page=${page}&limit=${limit}`, { headers });
            console.log("Response :", response);
            setPurchaseData(response?.data?.data?.procurementUnits);
            setFilteredData(response?.data?.data?.procurementUnits);
            setTotalPages(response?.data?.data?.totalPages);
        } catch (error) {
            console.log("Error in fetching purchase unit list :", error);
            setPurchaseData([]);
        } finally {
            setLoading(false);
        }
    }

    // Mock data - replace with actual API calls
    const mockPurchaseUnits = [
        {
            id: 1,
            name: "ABC Food Suppliers Pvt Ltd",
            type: "FOOD",
            contactPerson: "John Doe",
            mobile: "9876543210",
            email: "john@abcsuppliers.com",
            address: "123 Main Street, Business Park",
            city: "Mumbai",
            pincode: "400001",
            state: "Maharashtra",
            gstin: "27AABCU9603R1ZM",
            status: "ACTIVE",
            createdAt: "2024-01-15",
            totalOrders: 45
        },
        {
            id: 2,
            name: "XYZ Beverage Corporation",
            type: "BEVERAGE",
            contactPerson: "Jane Smith",
            mobile: "9876543211",
            email: "jane@xyzbev.com",
            address: "456 Oak Avenue, Industrial Area",
            city: "Delhi",
            pincode: "110001",
            state: "Delhi",
            gstin: "07BXYZC1234M1ZP",
            status: "ACTIVE",
            createdAt: "2024-01-10",
            totalOrders: 32
        },
        {
            id: 3,
            name: "Global Equipment Ltd",
            type: "EQUIPMENT",
            contactPerson: "Mike Johnson",
            mobile: "9876543212",
            email: "mike@globalequip.com",
            address: "789 Tech Park, Sector 15",
            city: "Bangalore",
            pincode: "560001",
            state: "Karnataka",
            gstin: "29CDEFG5678H1ZQ",
            status: "INACTIVE",
            createdAt: "2024-01-05",
            totalOrders: 18
        }
    ];

    const typeOptions = [
        { value: '', label: 'Select Type', icon: '' },
        { value: 'FOOD', label: 'Food Supplier', icon: '🍽️' },
        { value: 'BEVERAGE', label: 'Beverage Supplier', icon: '🥤' },
        { value: 'CENTRAL', label: 'Central', icon: '🔧' },
    ];

    const statusOptions = [
        { value: 'ACTIVE', label: 'Active', color: 'success' },
        { value: 'INACTIVE', label: 'Inactive', color: 'danger' }
    ];

    useEffect(() => {
        getPurchaseUnitsList(currentPage, recordsPerPage);
    }, []);

    useEffect(() => {
        filterData();
    }, [searchText, purchaseUnits]);

    const filterData = () => {
        if (!searchText) {
            setFilteredData(purchaseData);
            return;
        }

        const filtered = purchaseData?.filter(unit =>
            unit.name.toLowerCase().includes(searchText.toLowerCase()) ||
            unit.contactPerson.toLowerCase().includes(searchText.toLowerCase()) ||
            unit.email.toLowerCase().includes(searchText.toLowerCase()) ||
            unit.city.toLowerCase().includes(searchText.toLowerCase()) ||
            // unit.mobile.includes(searchText)
            String(unit.mobile || "").includes(searchText)
        );
        setFilteredData(filtered);
        setCurrentPage(1); // Reset to first page when searching
    };

    // Common input change handler for both forms
    const handleInputChange = (e, formType) => {
        const { name, value } = e.target;

        if (formType === 'add') {
            setAddFormData(prev => ({
                ...prev,
                [name]: value
            }));
        } else {
            setEditFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }

        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ""
            }));
        }
    };

    const handleSelectChange = (name, selectedOption, formType) => {
        const value = selectedOption ? selectedOption.value : "";

        if (formType === 'add') {
            setAddFormData(prev => ({
                ...prev,
                [name]: value
            }));
        } else {
            setEditFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }

        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ""
            }));
        }
    };

    const validateForm = (formData) => {
        const newErrors = {};

        if (!formData.name.trim()) newErrors.name = "Unit name is required";
        if (!formData.contactPerson.trim()) newErrors.contactPerson = "Contact person is required";

        if (!formData.mobile.trim()) newErrors.mobile = "Mobile is required";
        else if (!/^\d{10}$/.test(formData.mobile)) newErrors.mobile = "Please enter a valid 10-digit mobile number";

        if (!formData.email.trim()) newErrors.email = "Email is required";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = "Please enter a valid email";

        if (!formData.address.trim()) newErrors.address = "Address is required";
        if (!formData.city.trim()) newErrors.city = "City is required";

        if (!formData.pincode.trim()) newErrors.pincode = "Pincode is required";
        else if (!/^\d{6}$/.test(formData.pincode)) newErrors.pincode = "Please enter a valid 6-digit pincode";

        if (!formData.state.trim()) newErrors.state = "State is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleAddSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm(addFormData)) return;

        setIsSubmitting(true);

        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }

            const response = await axiosInstance.post('procurement-units', addFormData, { headers });
            console.log("Response of adding :", response);
            getPurchaseUnitsList(currentPage, recordsPerPage);
            resetAddForm();
            toast.success('Purchase unit added successfully!', {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
            handleCloseAddModal();
        } catch (error) {
            let errorMessage = '';
            if (error.response?.status === 406) {
                errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
            } else if (error.response?.status === 400) {
                errorMessage = error?.response?.data?.data?.message;
            } else if (error.response?.status === 404) {
                errorMessage = error?.response?.data?.data?.message;
            } else if (error.response?.status === 412) {
                errorMessage = error?.response?.data?.data?.message;
            } else if (error.response?.status === 500) {
                errorMessage = error?.response?.data?.error
            }

            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();

        // if (!validateForm(editFormData)) return;

        setIsSubmitting(true);

        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }

            // Update the API endpoint and payload according to your backend requirements
            const response = await axiosInstance.put(`procurement-units`, editFormData, { headers });
            console.log("Response of editing :", response);
            handleCloseEditModal();
            getPurchaseUnitsList(currentPage, recordsPerPage);
            toast.success('Purchase unit updated successfully!', {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        } catch (error) {
            let errorMessage = '';
            if (error.response?.status === 406) {
                errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
            } else if (error.response?.status === 400) {
                errorMessage = error?.response?.data?.data?.message;
            } else if (error.response?.status === 404) {
                errorMessage = error?.response?.data?.data?.message;
            } else if (error.response?.status === 412) {
                errorMessage = error?.response?.data?.data?.message;
            } else if (error.response?.status === 500) {
                errorMessage = error?.response?.data?.error
            }

            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleEdit = (unit) => {
        console.log("Open Edit Modal :", unit);

        setEditFormData({
            name: unit.name,
            type: unit.type,
            contactPerson: unit.contactPerson,
            mobile: unit.mobile,
            email: unit.email,
            address: unit.address,
            city: unit.city,
            pincode: unit.pincode,
            state: unit.state,
            gstin: unit.gstin,
            id: unit._id,
        });
        setEditingUnit(unit);
        setShowEditModal(true);
    };

    const handleDelete = async (unit) => {
        console.log("Unit of Delete :", unit);
        setUnitToDelete(unit);
        setSelectedUnit(unit?._id)
        setShowDeleteConfirm(true);
    };

    const confirmDelete = async () => {
        setActionLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }

            let reqBody = {
                id: selectedUnit
            }

            const response = await axiosInstance.delete(`/procurement-units`, { headers, data: reqBody })
            getPurchaseUnitsList(currentPage, recordsPerPage);
            toast.success('Purchase unit deleted successfully!', {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        } catch (error) {
            if (error.response.status === 403) {
                toast.error(error?.response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }

            if (error.response.status === 404) {
                toast.error(error?.response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }

            if (error.response.status === 406) {
                toast.error(error?.response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }

            if (error.response.status === 412) {
                toast.error(error?.response?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }

            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setActionLoading(false);
            setShowDeleteConfirm(false);
            setUnitToDelete(null);
        }
    };

    const resetAddForm = () => {
        setAddFormData({
            name: "",
            type: "",
            contactPerson: "",
            mobile: "",
            email: "",
            address: "",
            city: "",
            pincode: "",
            state: "",
            gstin: "",
        });
        setErrors({});
    };

    const handleCloseAddModal = () => {
        setShowAddModal(false);
        resetAddForm();
    };

    const handleCloseEditModal = () => {
        setShowEditModal(false);
        setEditingUnit(null);
        setEditFormData({
            name: "",
            type: "FOOD",
            contactPerson: "",
            mobile: "",
            email: "",
            address: "",
            city: "",
            pincode: "",
            state: "",
            gstin: "",
            status: "ACTIVE"
        });
        setErrors({});
    };

    const getTypeVariant = (type) => {
        switch (type) {
            case 'FOOD': return 'success';
            case 'BEVERAGE': return 'primary';
            case 'CENTRAL': return 'warning';
            case 'PACKAGING': return 'info';
            default: return 'secondary';
        }
    };

    const getStatusVariant = (status) => {
        return status === 'ACTIVE' ? 'success' : 'danger';
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        getPurchaseUnitsList(page, recordsPerPage);
    };

    const handleRecordsPerPageChange = (perPage) => {
        setRecordsPerPage(perPage);
        getPurchaseUnitsList(1, perPage);
        setCurrentPage(1);
    };

    // Calculate paginated data
    const paginatedData = useMemo(() => {
        return filteredData.slice(
            (currentPage - 1) * recordsPerPage,
            currentPage * recordsPerPage
        );
    }, [filteredData, currentPage, recordsPerPage]);

    const columns = [
        {
            header: "SR NO",
            accessor: "id",
            render: (value, row, index) => (
                <div className="text-center">{(currentPage - 1) * recordsPerPage + index + 1}</div>
            )
        },
        {
            header: "UNIT DETAILS",
            accessor: "name",
            render: (value, row) => (
                <div>
                    <div className="fw-semibold text-primary">{value}</div>
                    {/* <small className="text-muted">GST: {row.gstin}</small> */}
                    <div className="small text-muted mt-1">
                        <i className="ri-calendar-line me-1"></i>
                        Since {new Date(row.createdAt).toLocaleDateString()}
                    </div>
                </div>
            ),
        },
        {
            header: "TYPE",
            accessor: "type",
            render: (value) => {
                const typeOption = typeOptions.find(opt => opt.value === value);
                return (
                    <Badge bg={getTypeVariant(value)} className="px-2 py-1">
                        {typeOption?.icon} {typeOption?.label || value}
                    </Badge>
                );
            },
        },
        {
            header: "CONTACT PERSON",
            accessor: "contactPerson",
            render: (value) => <div className="fw-medium">{value}</div>,
        },
        {
            header: "CONTACT INFO",
            accessor: "mobile",
            render: (value, row) => (
                <div>
                    <div className="small">
                        <i className="ri-phone-line me-1"></i>
                        {value}
                    </div>
                    <div className="small text-muted">
                        <i className="ri-mail-line me-1"></i>
                        {row.email}
                    </div>
                </div>
            ),
        },
        {
            header: "LOCATION",
            accessor: "city",
            render: (value, row) => (
                <div>
                    <div className="small">
                        <i className="ri-map-pin-line me-1"></i>
                        {value}
                    </div>
                    <div className="small text-muted">{row.state}</div>
                </div>
            ),
        },
        {
            header: "ACTIONS",
            accessor: null,
            render: (_, row) => (
                <div className="text-center">
                    <Dropdown>
                        <Dropdown.Toggle
                            variant="outline-primary"
                            size="sm"
                            className="border-0"
                            disabled={actionLoading}
                        >
                            <i className="ri-more-2-fill"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu align="end">
                            {(purchaseAccess?.includes("PurchaseUnits:update") || email === 'contact@xpansecafe.com') && (
                                <Dropdown.Item
                                    className="text-primary"
                                    onClick={() => handleEdit(row)}
                                >
                                    <i className="ri-edit-line me-2"></i>
                                    Edit
                                </Dropdown.Item>
                            )}
                            {/* {(purchaseAccess?.includes("PurchaseUnits:get") || email === 'contact@xpansecafe.com') && (
                                <Dropdown.Item className="text-success">
                                    <i className="ri-eye-line me-2"></i>
                                    View Details
                                </Dropdown.Item>
                            )} */}
                            {(purchaseAccess?.includes("PurchaseUnits:delete") || email === 'contact@xpansecafe.com') && (
                                <Dropdown.Item
                                    className="text-danger"
                                    onClick={() => handleDelete(row)}
                                >
                                    <i className="ri-delete-bin-line me-2"></i>
                                    Delete
                                </Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            ),
        },
    ];

    const StatsCard = ({ title, value, icon, color }) => (
        <Card className="border-0 shadow-sm">
            <Card.Body className="p-3">
                <div className="d-flex align-items-center">
                    <div className={`bg-${color} bg-opacity-10 rounded p-2 me-3`}>
                        <i className={`ri-${icon} text-${color} fs-4`}></i>
                    </div>
                    <div>
                        <h4 className="mb-0 fw-bold">{value}</h4>
                        <small className="text-muted">{title}</small>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <Container className='bg-white' fluid>
                    {/* Header Section */}
                    <Row className="mb-2">
                        <Col className='mb-2'>
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <h4 className="fw-bold mb-1 mt-2">PURCHASE UNIT MANAGEMENT</h4>
                                    {/* <p className="text-muted mb-0">
                                        Manage your suppliers and vendors in one place
                                    </p> */}
                                </div>
                                <Button
                                    variant="primary"
                                    className="fw-semibold rounded-pill px-4 mt-2"
                                    onClick={() => setShowAddModal(true)}
                                    disabled={loading}
                                >
                                    <i className="ri-add-line me-2"></i>
                                    Add New Purchase Unit
                                </Button>
                            </div>
                        </Col>
                        <hr />
                    </Row>

                    {/* Stats Cards */}
                    <Row className="mb-4">
                        <Col md="3">
                            <StatsCard
                                title="Total Units"
                                value={purchaseData.length}
                                icon="building-4-line"
                                color="primary"
                            />
                        </Col>
                        <Col md="3">
                            <StatsCard
                                title="Food Suppliers"
                                value={purchaseData.filter(u => u.type === 'FOOD').length}
                                icon="check-double-line"
                                color="success"
                            />
                        </Col>
                        <Col md="3">
                            <StatsCard
                                title="Beverage Suppliers"
                                value={purchaseData.filter(u => u.type === 'BEVERAGE').length}
                                icon="restaurant-line"
                                color="info"
                            />
                        </Col>
                        <Col md="3">
                            <StatsCard
                                title="Central Suppliers"
                                value={purchaseData.filter(u => u.type === 'CENTRAL')?.length}
                                icon="shopping-cart-2-line"
                                color="warning"
                            />
                        </Col>
                        {/* <Col md="3">
                            <StatsCard
                                title="Total Orders (Dummy Count)"
                                value={purchaseUnits.reduce((sum, unit) => sum + unit.totalOrders, 0)}
                                icon="shopping-cart-2-line"
                                color="info"
                            />
                        </Col> */}
                    </Row>

                    {/* Search and Filters */}
                    <Card className="border-0 shadow-sm mb-4">
                        <Card.Body>
                            <Row className="g-3 align-items-center">
                                <Col lg="8">
                                    <div className="position-relative">
                                        <i className="ri-search-line position-absolute top-50 start-3 ms-3 translate-middle-y text-muted"></i>
                                        <Form.Control
                                            type="text"
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                            className="ps-5"
                                            placeholder="Search by name, contact, email, city or mobile..."
                                            onKeyPress={(e) => e.key === 'Enter' && filterData()}
                                        />
                                    </div>
                                </Col>
                                <Col lg="4" className="text-lg-start">
                                    <div className="d-flex gap-2 justify-content-lg-start">
                                        {/* <Button
                                            variant="outline-primary"
                                            onClick={filterData}
                                        >
                                            <i className="ri-search-line me-2"></i>
                                            Search
                                        </Button> */}
                                        <Button
                                            variant="outline-secondary"
                                            className='w-25'
                                            onClick={() => {
                                                setSearchText('');
                                                filterData();
                                            }}
                                        >
                                            <i className="ri-refresh-line me-2"></i>
                                            Reset
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>

                    {/* Table Section */}
                    <Card className="border-0 shadow-sm">
                        <Card.Body className="p-0">
                            {(purchaseAccess?.includes("PurchaseUnits:get") || email === 'contact@xpansecafe.com') && (
                                <div className="table-responsive">
                                    <Table hover className="mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                {columns.map((column, index) => (
                                                    <th key={index} className="text-nowrap py-3">
                                                        {column.header}
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan={columns.length} className="text-center py-5">
                                                        <Spinner animation="border" variant="primary" />
                                                        <div className="mt-2 text-muted">Loading purchase units...</div>
                                                    </td>
                                                </tr>
                                            ) : filteredData.length > 0 ? (
                                                filteredData.map((row, index) => (
                                                    <tr key={row.id} className="align-middle">
                                                        {columns.map((column, colIndex) => (
                                                            <td key={colIndex} className="py-3">
                                                                {column.render
                                                                    ? column.render(row[column.accessor], row, index)
                                                                    : row[column.accessor]
                                                                }
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={columns.length} className="text-center py-5">
                                                        <div className="py-4">
                                                            <i className="ri-inbox-line ri-4x text-muted mb-3"></i>
                                                            <h5 className="text-muted">No purchase units found</h5>
                                                            {searchText && (
                                                                <p className="text-muted mb-3">
                                                                    No results found for "<strong>{searchText}</strong>"
                                                                </p>
                                                            )}
                                                            {/* <Button
                                                                variant="primary"
                                                                onClick={() => setShowAddModal(true)}
                                                            >
                                                                <i className="ri-add-line me-2"></i>
                                                                Add Your First Unit
                                                            </Button> */}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>

                                    {/* Pagination */}
                                    {filteredData.length > 0 && (
                                        <div className="d-flex justify-content-between align-items-center p-3 border-top">
                                            <div className="text-muted small">
                                                Showing {((currentPage - 1) * recordsPerPage) + 1} to {Math.min(currentPage * recordsPerPage, filteredData.length)} of {filteredData.length} entries
                                            </div>

                                            <div className="d-flex align-items-center gap-3">
                                                <Form.Group className="d-flex align-items-center mb-0">
                                                    <Form.Label className="mb-0 me-2 small">Show:</Form.Label>
                                                    <Form.Select
                                                        size="sm"
                                                        value={recordsPerPage}
                                                        onChange={(e) => handleRecordsPerPageChange(Number(e.target.value))}
                                                        style={{ width: '80px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={25}>25</option>
                                                        <option value={50}>50</option>
                                                    </Form.Select>
                                                </Form.Group>

                                                <div className="d-flex align-items-center gap-1">
                                                    <Button
                                                        variant="outline-primary"
                                                        size="sm"
                                                        onClick={() => handlePageChange(Math.max(currentPage - 1, 1))}
                                                        disabled={currentPage === 1}
                                                    >
                                                        <i className="ri-arrow-left-s-line"></i>
                                                    </Button>

                                                    <div className="mx-2 text-nowrap small">
                                                        Page <span className="fw-bold">{currentPage}</span> of <span className="fw-bold">{totalPages}</span>
                                                    </div>

                                                    <Button
                                                        variant="outline-primary"
                                                        size="sm"
                                                        onClick={() => handlePageChange(Math.min(currentPage + 1, totalPages))}
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <i className="ri-arrow-right-s-line"></i>
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </Card.Body>
                    </Card>

                    <div className='mt-1'>
                        <br />
                    </div>

                    {/* Add Purchase Unit Modal */}
                    {showAddModal && (
                        <Modal
                            size="lg"
                            centered
                            show={showAddModal}
                            onHide={handleCloseAddModal}
                            backdrop="static"
                        >
                            <Modal.Header closeButton className="border-bottom">
                                <Modal.Title>
                                    <i className="ri-building-4-line me-2"></i>
                                    ADD NEW PURCHASE UNIT
                                </Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleAddSubmit}>
                                <Modal.Body className="pb-1">
                                    <Alert variant="info" className="py-2">
                                        <i className="ri-information-line me-2"></i>
                                        Fill in the details to add a new purchase unit to your system.
                                    </Alert>

                                    <Row>
                                        <Col md="6">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Unit Name <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="name"
                                                    value={addFormData.name}
                                                    onChange={(e) => handleInputChange(e, 'add')}
                                                    isInvalid={!!errors.name}
                                                    placeholder="Enter unit name"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.name}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col md="6">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Type <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Select
                                                    components={animatedComponents}
                                                    options={typeOptions}
                                                    value={typeOptions?.find(option => option.value === addFormData.type)}
                                                    onChange={(selected) => handleSelectChange('type', selected, 'add')}
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    placeholder="Select Type"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md="6">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Contact Person <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="contactPerson"
                                                    value={addFormData.contactPerson}
                                                    onChange={(e) => handleInputChange(e, 'add')}
                                                    isInvalid={!!errors.contactPerson}
                                                    placeholder="Enter contact person name"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.contactPerson}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col md="6">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Mobile <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="tel"
                                                    name="mobile"
                                                    value={addFormData.mobile}
                                                    onChange={(e) => handleInputChange(e, 'add')}
                                                    isInvalid={!!errors.mobile}
                                                    placeholder="Enter 10-digit mobile number"
                                                    maxLength="10"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.mobile}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md="12">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Email <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    name="email"
                                                    value={addFormData.email}
                                                    onChange={(e) => handleInputChange(e, 'add')}
                                                    isInvalid={!!errors.email}
                                                    placeholder="Enter email address"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.email}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        {/* <Col md="6">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    GSTIN
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="gstin"
                                                    value={addFormData.gstin}
                                                    onChange={(e) => handleInputChange(e, 'add')}
                                                    isInvalid={!!errors.gstin}
                                                    placeholder="Enter 15-character GSTIN"
                                                    style={{ textTransform: 'uppercase' }}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.gstin}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col> */}
                                    </Row>

                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold">
                                            Address <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            name="address"
                                            value={addFormData.address}
                                            onChange={(e) => handleInputChange(e, 'add')}
                                            isInvalid={!!errors.address}
                                            placeholder="Enter complete address"
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.address}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Row>
                                        <Col md="4">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Pincode <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="pincode"
                                                    value={addFormData.pincode}
                                                    onChange={(e) => handleInputChange(e, 'add')}
                                                    isInvalid={!!errors.pincode}
                                                    placeholder="Enter 6-digit pincode"
                                                    maxLength="6"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.pincode}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col md="4">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    City <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="city"
                                                    value={addFormData.city}
                                                    onChange={(e) => handleInputChange(e, 'add')}
                                                    isInvalid={!!errors.city}
                                                    placeholder="Enter city"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.city}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col md="4">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    State <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="state"
                                                    value={addFormData.state}
                                                    onChange={(e) => handleInputChange(e, 'add')}
                                                    isInvalid={!!errors.state}
                                                    placeholder="Enter state"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.state}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer className="border-top">
                                    <Button
                                        variant="outline-secondary"
                                        onClick={handleCloseAddModal}
                                        disabled={isSubmitting}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="primary"
                                        type="submit"
                                        disabled={isSubmitting}
                                        className="px-4"
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <Spinner size="sm" className="me-2" />
                                                Adding...
                                            </>
                                        ) : (
                                            'ADD PURCHASE UNIT'
                                        )}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    )}

                    {/* Edit Purchase Unit Modal */}
                    {showEditModal && (
                        <Modal
                            size="lg"
                            centered
                            show={showEditModal}
                            onHide={handleCloseEditModal}
                            backdrop="static"
                        >
                            <Modal.Header closeButton className="border-bottom">
                                <Modal.Title>
                                    <i className="ri-edit-line me-2"></i>
                                    EDIT PURCHASE UNIT
                                </Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleEditSubmit}>
                                <Modal.Body className="pb-1">
                                    {/* <Alert variant="warning" className="py-2">
                                        <i className="ri-information-line me-2"></i>
                                        Update the details for {editingUnit?.name}.
                                    </Alert> */}

                                    <Row>
                                        <Col md="6">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Unit Name <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="name"
                                                    value={editFormData.name}
                                                    onChange={(e) => handleInputChange(e, 'edit')}
                                                    isInvalid={!!errors.name}
                                                    placeholder="Enter unit name"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.name}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col md="6">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Type <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Select
                                                    components={animatedComponents}
                                                    options={typeOptions}
                                                    value={typeOptions?.find(option => option.value === editFormData.type)}
                                                    onChange={(selected) => handleSelectChange('type', selected, 'edit')}
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    placeholder="Select Type"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md="6">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Contact Person <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="contactPerson"
                                                    value={editFormData.contactPerson}
                                                    onChange={(e) => handleInputChange(e, 'edit')}
                                                    isInvalid={!!errors.contactPerson}
                                                    placeholder="Enter contact person name"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.contactPerson}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col md="6">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Mobile <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="tel"
                                                    name="mobile"
                                                    value={editFormData.mobile}
                                                    onChange={(e) => handleInputChange(e, 'edit')}
                                                    isInvalid={!!errors.mobile}
                                                    placeholder="Enter 10-digit mobile number"
                                                    maxLength="10"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.mobile}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md="12">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Email <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    name="email"
                                                    value={editFormData.email}
                                                    onChange={(e) => handleInputChange(e, 'edit')}
                                                    isInvalid={!!errors.email}
                                                    placeholder="Enter email address"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.email}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        {/* <Col md="6">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    GSTIN
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="gstin"
                                                    value={editFormData.gstin}
                                                    onChange={(e) => handleInputChange(e, 'edit')}
                                                    isInvalid={!!errors.gstin}
                                                    placeholder="Enter 15-character GSTIN"
                                                    style={{ textTransform: 'uppercase' }}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.gstin}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col> */}
                                    </Row>

                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold">
                                            Address <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            name="address"
                                            value={editFormData.address}
                                            onChange={(e) => handleInputChange(e, 'edit')}
                                            isInvalid={!!errors.address}
                                            placeholder="Enter complete address"
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.address}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Row>
                                        <Col md="4">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Pincode <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="pincode"
                                                    value={editFormData.pincode}
                                                    onChange={(e) => handleInputChange(e, 'edit')}
                                                    isInvalid={!!errors.pincode}
                                                    placeholder="Enter 6-digit pincode"
                                                    maxLength="6"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.pincode}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col md="4">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    City <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="city"
                                                    value={editFormData.city}
                                                    onChange={(e) => handleInputChange(e, 'edit')}
                                                    isInvalid={!!errors.city}
                                                    placeholder="Enter city"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.city}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col md="4">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    State <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="state"
                                                    value={editFormData.state}
                                                    onChange={(e) => handleInputChange(e, 'edit')}
                                                    isInvalid={!!errors.state}
                                                    placeholder="Enter state"
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.state}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    {/* <Row>
                                        <Col md="6">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold">
                                                    Status <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Select
                                                    components={animatedComponents}
                                                    options={statusOptions}
                                                    value={statusOptions.find(option => option.value === editFormData.status)}
                                                    onChange={(selected) => handleSelectChange('status', selected, 'edit')}
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    placeholder="Select Status"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row> */}
                                </Modal.Body>
                                <Modal.Footer className="border-top">
                                    <Button
                                        variant="outline-secondary"
                                        onClick={handleCloseEditModal}
                                        disabled={isSubmitting}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="primary"
                                        type="submit"
                                        disabled={isSubmitting}
                                        className="px-4"
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <Spinner size="sm" className="me-2" />
                                                Updating...
                                            </>
                                        ) : (
                                            'UPDATE PURCHASE UNIT'
                                        )}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    )}

                    {/* Delete Confirmation Modal */}
                    <Modal
                        show={showDeleteConfirm}
                        onHide={() => setShowDeleteConfirm(false)}
                        centered
                    >
                        <Modal.Header closeButton>
                            <Modal.Title className="text-danger">
                                <i className="ri-delete-bin-line me-2"></i>
                                Confirm Deletion
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Alert variant="warning" className="mb-0">
                                <i className="ri-alert-line me-2"></i>
                                Are you sure you want to delete <strong>{unitToDelete?.name}</strong>?
                                This action cannot be undone and will remove all associated data.
                            </Alert>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="outline-secondary"
                                onClick={() => setShowDeleteConfirm(false)}
                                disabled={actionLoading}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="danger"
                                onClick={confirmDelete}
                                disabled={actionLoading}
                            >
                                {actionLoading ? (
                                    <>
                                        <Spinner size="sm" className="me-2" />
                                        Deleting...
                                    </>
                                ) : (
                                    'Delete Unit'
                                )}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default PurchaseUnits;